export const media = {
  mobile: "(min-width: 480px)",
  tablet: "(min-width: 768px)",
  "tablet-large": "(min-width: 900px)",
  laptop: "(min-width: 1024px)",
  desktop: "(min-width: 1140px)",
  "desktop-large": "(min-width: 1280px)",
  screen: "(min-width: 1540px)",
};
